import React, {useContext, useEffect, useState} from "react";
import CookiesJS from "js-cookie";
import { getSafeCookie } from '../../helpers/cookieHelper';
import {Panel, PanelType} from "@fluentui/react/lib/Panel";
import {DefaultButton} from "@fluentui/react/lib/Button";
import {useBoolean} from "@fluentui/react-hooks";
import {useParams} from "react-router-dom";

import SubMenu from "../../components/navigation/subMenu/subMenu.component";
import ListHeader from "../../components/lists/listHeader/listHeader.component";
import PanelClient from "../admin/client/panelClient";
import logo from '../../assets/img/images'
import {RequestFetch} from "../../utils/Requests/requests.Controller";
import DetailsListBext from "../../components/lists/DetailsList/detailsList.component";
import LenguajeContext from "../../context/Lenguaje/lenguajeContext";
import ContainerLargeForm from "../../components/containers/largeForm/containerLargeForm.component";

const Captchas =  () => {
  const dataClient = getSafeCookie("dataClient");
  const idClient = dataClient?.idClient;
  const {clientName} = useParams();

  const [captchaList, setCaptchaList] = useState([]);
  
  const [pagination, setPagination] = useState(null);
  const [clientsItems, setClientsItems] = useState([])
  const [controlsPage, setControlsPage] = useState({});
  const [campForm, setcampForm] = useState([])
  const [formValues, setFormValues] = useState({});
  const {getLenguaje, stateLanguage} = useContext(LenguajeContext);

  const requestsClients = new RequestFetch("Client/Captcha");
  const RequestsCaptcha = new RequestFetch("Captcha");
  const RequestKeyType = new RequestFetch('DynamicKeyType');
  const RequestsLanguages = new RequestFetch("Languages")
  const [clientSelected, setClientSelected] = useState()
  const [disableInputa, setDisableInputa] = useState([
    { disable: false, key: "valueDefault" },
    { disable: true, key: "idCaptcha" }
  ])

  const shouldHideCaptchaFields = (captchaId) => {
    return captchaId === 1;
  };

  const COLUMN_TITLES = [{
    path: {
      name: "Nombre",
      maxWidth: 150
    },
    dailyPasswordLimit: {
      name:"Tiempo de vigencia de la clave dinámica",
      maxWidth: 150,
      isMultiline: true
    },
    dynamicKeyLength:{
      name: "Tiempo de clave dinámica",
      maxWidth: 150
    },
    appMobile:{
      name: "Teclado virtual",
      maxWidth: 180
    },
    captchaName:{
      name: "Captcha habilitado",
      maxWidth: 130
    }
  }];

  const [filter, setFilter] = useState({
    pageSize: 5,
    pageNumber: "0",
    idDomain: ""
  });
  const [isLoadedOptionsData, {
    setTrue: handleLoadedOptionsData
  }] = useBoolean(false);

  const [isLoadingData, {
    setTrue: handleLoadingData,
    setFalse: handleLoadedData
  }] = useBoolean(true);
  const [isOpen, {
    setTrue: openPanel,
    setFalse: dismissPanel
  }] = useBoolean(false);

  const [isOpenCaptcha, {
    setTrue: openPanelCaptcha,
    setFalse: dismissPanelCaptcha
  }] = useBoolean(false);

  const loadPanel = () => {

    const selectedCaptchaId = clientSelected?.clients_Captchas[0]?.idCaptcha;

    const fieldsDefault = campForm.map(camp => {
      
      if (shouldHideCaptchaFields(selectedCaptchaId) && 
          ['endPoint', 'siteKey', 'secretKey'].includes(camp.key)) {
        return null
      }

      const value = (function() {
        switch(camp.key){
          case "idCaptcha":
            return clientSelected?.clients_Captchas[0]?.idCaptcha || null
          case "endPoint":
            return clientSelected?.clients_Captchas[0]?.endPoint || null
          case "siteKey":
            return clientSelected?.clients_Captchas[0]?.siteKey || null
          case "secretKey":
            return clientSelected?.clients_Captchas[0]?.secretKey || null
        }
      })();

      camp = {
        ...camp,
        defaultValue: value,
        defaultValu: value
      }
      return camp
    }).filter(Boolean)
    
    setcampForm(fieldsDefault)

    openPanel()
  }

  useEffect(() => {
    async function onFilterChange(){
      if (filter.pageNumber > 0) {
        await executeClientsQuery();
      }
    }
    onFilterChange();
  }, [filter])

  useEffect( () => {
    async function onInit(){
      const [captchaResponse] = await Promise.all([
        methodsRequests.loadCaptchaList(clientName),
        methodsRequests.loadDynamicKeyList(clientName),
        methodsRequests.loadLanguagesList(clientName, idClient)
      ]);
      handleLoadedOptionsData();
      await executeClientsQuery(captchaResponse);
    }
    onInit();
  }, [])

  useEffect(() => {
    let controlsPage = {};
    if (stateLanguage.lenguaje !=0) {
        //console.log(stateLanguage);
        stateLanguage.lenguaje.map((pass) => {
          // console.log(pass)
            if (pass.path == 'controls'|| pass.path =='domain') {
              pass.webcontrolspages.map((data) => {
                controlsPage[data.idHtml] = data.languagewebcontrols[0];
              })    
              setControlsPage(controlsPage)
            }              
        })          
    }

  }, [stateLanguage])

  const executeClientsQuery = async (captchaElements = captchaList) => {
    await methodsRequests.getClients(filter, clientName, captchaElements);
  }

  const _defaultRenderItemColumn = (item, index, column) => {
    const fieldContent = item[column.fieldName];
    return <span>{fieldContent}</span>;
  }

  const actionOnChange = (data) =>{
    // switch (data?.id) {
    //   case 'idCaptcha':
    //     if (data.key != 1 && data.key != '') {
          
    //       setcampForm(current=>{
    //         console.log(current)
    //         return current
    //       })
    //     }
    //     break;
    
    //   default:
    //     break;
    // }
    const value = (function () {
      switch (data?.id) {
        case "idCaptcha":        
          return data?.key;
        default:
          return data?.selectedItem;
      }
    })();
    if ( formValues[data.id] !== value && value !== undefined) {
      setFormValues(currentValue => ({
        ...currentValue,
        [data.id]: value
      }));
    }
  }

  useEffect(() => {
    if (captchaList && captchaList.length>0) {
      const optionCaptcha = captchaList.map(
        captcha => ({
          key: captcha.id,
          text: captcha.name,
          img: true,
          imageSrc: logo[captcha.name],
          imageSize: {width: "160px", height: "50px"},
          selectedImageSrc: logo[captcha.name]
        })
      )

      const currentCaptchaId = formValues.idCaptcha || clientSelected?.clients_Captchas[0]?.idCaptcha;
      const hideFields = shouldHideCaptchaFields(currentCaptchaId);
      
      const baseFields = [
        {
          id: 0,
          type: "radio2",
          key: "idCaptcha",
          label: "Seleccione captcha",
          options: optionCaptcha,
          img: true,
          disabled: false,
          className: 'radio-capt'
        }
      ];
      if (!hideFields) {
        baseFields.push(
          // {
        //   id: 1,
        //   key: "path",
        //   label: "Contraseña",
        //   type: "text2",
        //   disabled: true,
        //   onRenderLabel: null,
        //   className: 'select2',
        //   required: true,
        //   max: 12,
        //   min: 5,
        //   errorMessage: 'debe llenar este campo'
        // },
          {
            id: 1,
            key: "endPoint",
            label: "EndPoint",
            type: "text2",
            disabled: true,
            onRenderLabel: null,
            className: 'select2',
            required: true,
            max: 100,
            min: 5,
            errorMessage: 'debe llenar este campo'
          },
          {
            id: 2,
            key: "siteKey",
            label: "Clave de Sitio de Google",
            type: "text2",
            disabled: true,
            multiline: false,
            resizable: false,
            typeInput: "password",
            autoComplete:"new-password",
            canRevealPassword: true,
            idHtml: "lblMailPasword",
            onRenderLabel: null,
            className: 'select2',
            required: true,
            max: 100,
            min: 5,
            errorMessage: 'debe llenar este campo'
          },
          {
            id: 3,
            key: "secretKey",
            label: "Clave secreta de Google",
            type: "text2",
            disabled: true,
            multiline: false,
            resizable: false,
            typeInput: "password",
            autoComplete:"new-password",
            canRevealPassword: true,
            idHtml: "lblMailPasword",
            onRenderLabel: null,
            className: 'select2',
            required: true,
            max: 100,
            min: 5,
            errorMessage: 'debe llenar este campo'
          }
        );
      }
    
      setcampForm(baseFields);
    }
    
  }, [captchaList, formValues.idCaptcha])


  const campFilters = [
    {
      id: 1,
      key: 'searchValue',
      label: '',
      type: 'text',
    }
  ]

  const methodsRequests = {
    loadCaptchaList: async (tenant) => {
      const captcha = await RequestsCaptcha.getItem({tenant});
      if (captcha.data.data) {
        setCaptchaList(captcha.data.data)
      }
      return captcha?.data?.data || [];
    },
    loadLanguagesList: async (tenant, idClient) => {
      const languages = await RequestsLanguages.getItem({tenant, param: {idClient}})
      
      return languages?.data?.data || [];
    },
    loadDynamicKeyList: async (tenant, idClient) => {
      const dynamicKeys = await RequestKeyType.getItem({tenant});
      return dynamicKeys?.data?.data || [];
    },
    getClients: async (filters, tenant, captchaMap) => {
      handleLoadingData();
      setPagination(null);
      const response = await requestsClients.getItem({param: filters, tenant});
      if (response.data.data) {
        setClientsItems(
          response.data.data.map(client => {
            let clientMap = {
              ...client,
              appMobile: client.useVirtualKeyboard ? 'Habilitado' : 'Deshabilitado',
              captchaName: "Ninguno"
            }
            if (captchaMap) {

              const captchaName = captchaMap.find(captcha => captcha.id === client.clients_Captchas[0]?.idCaptcha)?.name;
              if (captchaName) {
                clientMap = {
                  ...clientMap,
                  captchaName
                }
              }
            }
            return clientMap
          })
        )
      }
      const {
        currentPage,
        pageZise,
        totalCount,
        totalPages
      } = response.data.meta;
      setPagination({
        currentPage: currentPage,
        pageSize: pageZise,
        totalItems: totalCount,
        totalPages: totalPages
      });

      handleLoadedData();
    },
    updateItem: (payload, id) => {
       RequestsCaptcha.confirmRequest({
        body: payload,
        id: id,
        ct: "json",
        tenant: clientName,
        option: 'updateItem',
        infoModal:{
          title:controlsPage?.lblSuccessfulProcess?.value,
          description:controlsPage?.lblTheInformationHBeenRegisteredCorrectly?.value
          },
          op:"b"
      })
    }
  };

  const _handleSelectClient = (items) => {
    if (items.length > 0) {
      setClientSelected(items[0]);
    } else {
      setClientSelected(null);
    }
  }

  const submitForm = async () => {
    let captchaItem = captchaList.find(x => x.id === formValues.idCaptcha)
    let payload = {
      ...formValues,  
      name: captchaItem?.name,
      isInvisible : captchaItem?.isInvisible,
      isNative: captchaItem?.isNative,
      clients_Captchas: [
        {
          id: clientSelected?.clients_Captchas?.[0]?.id || 0,
          idClient: clientSelected?.id, // ID del cliente seleccionado
          idCaptcha: formValues.idCaptcha, // ID del captcha seleccionado
          isSelected: true, // Asumo que siempre es true cuando se envía
          endPoint: formValues.endPoint,
          siteKey: formValues.siteKey,
          secretKey: formValues.secretKey
        }
      ]
    }
    methodsRequests.updateItem(payload, formValues.idCaptcha, clientName);
  }

  return (
    <>
      <SubMenu
      key='keySubmenu'
        contentcontrols={
          isLoadedOptionsData ?
            clientSelected ?
            [
              {
                text:'Configurar Captcha',
                iconProps:{iconName: 'Edit'},
                onClick:() => loadPanel()
              }
              // ,
              // {
              //   text:'Configurar Captcha',
              //   iconProps:{iconName: 'Edit'},
              //   onClick:() => openPanelCaptcha()
              // }
            ]:[]
              // :
            // [
            //   {
            //     text:'Nuevo Cliente',
            //     iconProps:{iconName: 'Add'},
            //     onClick: () => openPanel()
            //   }
            // ]
          :[]
        }
        contentcontrolsTwo={
          <>
            <Panel
              isOpen={isOpen}
              closeButtonAriaLabel="Close"
              isHiddenOnDismiss={true}
              type={PanelType.medium}
              key={'fgdgfgf'}
              hasCloseButton={false}
            >
              {isOpen && (
                <ContainerLargeForm
                  dataForm={_ => {}}
                  controlsPage={controlsPage}
                  clientSelected={clientSelected}
                  onClosePanel={async(actionExecuted = false) => {
                    dismissPanel();
                    if(actionExecuted){
                      await executeClientsQuery();
                    }
                  }}
                  formTitle={ clientSelected? 'Editar restricción de IP' : 'Nueva restricción de IP'}
                  Items={campForm}
                  actionOnChange={actionOnChange}
                  onSubmitEventFormPanel={submitForm}
                  closePanel={dismissPanel}
                  isDisableOpt={disableInputa}
                />
              )}
            </Panel>
          </>
        }
      />
      <div className="admin--body-container">
        <ListHeader
          filters={campFilters}
          showReport={false}
          hideSearch={true}
          subRute="Administración / Clientes | "
          subRute3=" Configuración de clientes"
          title="Configuración de clientes"
          onChange={(event) => {
            setFilter({
              ...filter,
              pageSize: event.target.value,
              pageNumber: filter.pageNumber === "0" ? "0" : "1"
            });
          }}
          dataForm={({searchValue}) => {
            setFilter({
              ...filter,
              pageNumber: "1",
              search: searchValue
            });
          }}
        />
        <DetailsListBext
          enableShimmer={isLoadingData}
          listKey="supportBsrList"
          selectionMode={1}
          items={clientsItems}
          renderItemColumn={_defaultRenderItemColumn}
          columnTitles={COLUMN_TITLES}
          onSelect={_handleSelectClient}
          onPageChange={page => {
            if (page !== +filter.pageNumber) {
              setFilter({
                ...filter,
                pageNumber: String(page),
              });
            }
          }}
          pagination={pagination}
        />
      </div>
    </>
  );
};
export default Captchas;
